export default function TableRenderer({ table }) {
  console.log('Rendering table with data:', table)
  const columns = table?.columns || table?.Columns;
  const rows = table?.rows || table?.Rows;

  if (!columns?.length || !rows?.length) return null;
  const formatValue = (val) => {
    if (val === null || val === undefined) return '';
    if (typeof val === 'object') return JSON.stringify(val);
    if (typeof val === 'number' && Number.isFinite(val)) {
      return val.toLocaleString('en-US', { maximumFractionDigits: 2 });
    }

    const str = String(val).trim();
    if (str === '') return '';

    // Only localize values that are purely numeric; keep ranges/text as-is.
    const isStrictNumber = /^-?\d+(?:\.\d+)?$/.test(str);
    if (isStrictNumber) {
      const num = Number(str);
      return Number.isFinite(num)
        ? num.toLocaleString('en-US', { maximumFractionDigits: 2 })
        : str;
    }

    return String(val);
  };

  return (
    <div className="my-2 w-full flex flex-col py-1 max-h-[320px]">
      {(  table.title || table.Title ) && (
        <h4 className="text-sm font-semibold text-slate-700 dark:text-slate-300 mb-1.5 flex-shrink-0">{table.title}</h4>
      )}
      <div className="overflow-auto app-scrollbar flex-1 min-h-0 rounded-lg border border-slate-300 dark:border-slate-600">
        <table className="w-full table-auto text-sm border-collapse dark:bg-slate-800 bg-white">
          <thead className="sticky top-0 z-10 bg-slate-100 dark:bg-slate-900">
            <tr>
              {columns?.map((col) => (
                <th key={col} className="px-3 py-2.5 text-left text-xs font-semibold text-slate-700 dark:text-slate-200 border border-slate-300 dark:border-slate-600 whitespace-nowrap">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows?.map((row, i) => (
              <tr key={i}>
                {row.map((cell, j) => (
                  <td key={j} className="px-3 py-2.5 text-slate-700 dark:text-slate-300 whitespace-nowrap align-top border border-slate-300 dark:border-slate-700">
                    {formatValue(cell)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
